import { FormattedUnits } from "@/constants/common";
import { Country } from "@/types/enumerations";
import { t, TFunction } from "i18next";
import { EanPrefix, EicPrefix } from "@/constants/common";

const supStyles = {
  fontSize: "x-small",
  lineHeight: "normal",
};

export const formatMeasureUnits = (value: string | null) => {
  if (value === "kwh") {
    return FormattedUnits.kWh;
  }

  if (value === "kw") {
    return FormattedUnits.kW;
  }

  if (value === "mwh") {
    return FormattedUnits.MWh;
  }

  if (!value) {
    return "";
  }
  const numbers = value.match(/(\d+)/g);
  if (!numbers) {
    return value;
  }
  const numberIndex = value.indexOf(numbers[0]);
  const start = value.substring(0, numberIndex);
  const end = value.substring(numberIndex, value.length - 1);
  return (
    <>
      {start}
      <sup style={supStyles}>{value.at(numberIndex)}</sup>
      {end}
    </>
  );
};

export const formatMeasurementUnitsToString = (value: string): string => {
  value = value.toLowerCase();
  if (value === "kwh") {
    return FormattedUnits.kWh;
  }

  if (value === "kw") {
    return FormattedUnits.kW;
  }

  if (value === "mwh") {
    return FormattedUnits.MWh;
  }

  if (value === "m3") {
    return FormattedUnits.m3;
  }
  return value;
};

type Value = string | number | null | undefined;

export const kW = (value: Value) => value && `${value} ${FormattedUnits.kW}`;

export const kWh = (value: Value) => value && `${value} ${FormattedUnits.kWh}`;

export const m3 = (value: Value) => value && `${value} ${FormattedUnits.m3}`;

export const currency = (value: Value) =>
  value &&
  t("currency", {
    value,
    formatParams: {
      value: {
        currency: "CZK",
        maximumFractionDigits: 0,
      },
    },
  });

export const phone = (value: Value, countryCode = "CZ", countries: Country[]) => {
  if (!value) {
    return value;
  }

  const country = countries.find(c => c.value === countryCode);

  if (countryCode === "CZ") {
    const splitBy3 = value.toString().match(/.{1,3}/g);

    return splitBy3 && `${country?.telephoneCode} ${splitBy3.join(" ")}`;
  }

  return `${country?.telephoneCode} ${value}`;
};

export const getNumberUnit = (value: number | null | undefined) => {
  if (!value) {
    return null;
  }
  return value;
};

export const getCodeWithoutPrefix = (code: string | null | undefined) => {
  if (!code) {
    return "";
  }
  if (code.startsWith(EicPrefix)) {
    return code.substring(EicPrefix.length, code.length);
  }
  if (code.startsWith(EanPrefix)) {
    return code.substring(EanPrefix.length, code.length);
  }
  return code;
};

export const getStringUnit = (value: number | string | null | undefined) => {
  if (!value) {
    return "";
  }
  return `${value}`;
};

export const formatNumber = (value?: number | null, digits?: number) =>
  new Intl.NumberFormat("cs-cz", { maximumFractionDigits: digits ?? 0 }).format(value ?? 0);

export const roundToTwoDecimals = (value: number) => {
  return Math.round(value * 100) / 100;
};

export const translatedDepositFrequency = (value: string | null, t: TFunction<"common">) => {
  switch (value) {
    case "01":
      return t("monthly");
    case "02":
      return t("bimonthly");
    case "03":
      return t("quarterly");
    case "06":
      return t("semiAnnually");
    case "12":
      return t("annually");
    default:
      return t("monthly");
  }
};
